import React, { useEffect } from 'react';
import TwDialog from '../TwDialog/TwDialog';
import { ReactComponent as Warning } from '../../assets/icons/warning.svg';
import { TwButton, TwButtonType } from '../TwButtons/TwButtons';

export interface TwWarningProps {
  warningTitle: string;
  warningMessage: string | JSX.Element | undefined;
  open: boolean;
  handleClose: () => void;
  showWarning: boolean;
  setShowWarning: React.Dispatch<React.SetStateAction<boolean>>;
  reloadId?: string;
  reloadObject?: any;
  customizedContinue?: { label: string; type: TwButtonType };
  onContinue?: () => void;
  showCancelButton?: boolean;
  customIcon?: JSX.Element;
  disabled?: boolean;
}

const TwWarning: React.FC<TwWarningProps> = ({
  warningTitle,
  warningMessage,
  open,
  handleClose,
  showWarning,
  setShowWarning,
  reloadId,
  reloadObject,
  onContinue,
  customizedContinue,
  showCancelButton = true,
  customIcon,
  disabled = false
}): JSX.Element => {
  useEffect(() => {
    open && setShowWarning(true);
  }, [reloadId, reloadObject, open]);

  const handleCloseWarning = (): void => {
    setShowWarning(false);
    handleClose();
  };

  const handleContinue = (): void => {
    setShowWarning(false);
    onContinue && onContinue();
  };
  return (
    <TwDialog open={showWarning} title={warningTitle} onClickClose={handleCloseWarning}>
      <div className="warning tid-warning__content">
        {customIcon ? customIcon : <Warning />}
        <div className="warning__message">{warningMessage}</div>
        <div className="warning__actions tid-warning__actions">
          {showCancelButton && (
            <TwButton
              fullwidth={false}
              label="Cancel"
              type={TwButtonType.secondary}
              action={handleCloseWarning}
            />
          )}

          <TwButton
            className="tid-warning__continue"
            fullwidth={false}
            label={customizedContinue?.label || 'Continue'}
            type={customizedContinue?.type || TwButtonType.primary}
            action={handleContinue}
            disabled={disabled}
          />
        </div>
      </div>
    </TwDialog>
  );
};

export default TwWarning;
